<template>
	<div class="theiaStickySidebar" style="padding-top: 0px; padding-bottom: 1px; position: static; transform: none; top: 0px; left: 896.5px;">
        <aside class="sidebar-widget-area normal">
            <div id="search-2" class="widget widget_search">
                <div class="rt-widget-title-holder">
                    <h3 class="widgettitle has-animation active-animation">Search</h3>
                </div>
                <div style="display: flex;">
                    <el-autocomplete v-model="queryString" :fetch-suggestions="debounceQuery" placeholder="Search Here ..."
                        class="m-search"
                        popper-class="m-search-item" @select="handleSelect">	
                        <template slot-scope="{ item }">
                            <div class="title">{{ item.title }}</div>
                            <span class="text-content">{{ item.content }}</span>
                        </template>
                    </el-autocomplete>
                    <button style="cursor:pointer;color:#fff;width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;background-color: #2c3e50;border:none;border-radius: 8px;">
                        <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.1249 16.2411L12.4049 11.5211C13.5391 10.1595 14.1047 8.41291 13.9841 6.64483C13.8634 4.87675 13.0657 3.22326 11.7569 2.02834C10.4482 0.833415 8.7291 0.189061 6.95736 0.229318C5.18562 0.269575 3.49761 0.991344 2.24448 2.24448C0.991344 3.49761 0.269575 5.18562 0.229318 6.95736C0.189061 8.7291 0.833415 10.4482 2.02834 11.7569C3.22326 13.0657 4.87675 13.8634 6.64483 13.9841C8.41291 14.1047 10.1595 13.5391 11.5211 12.4049L16.2411 17.1249L17.1249 16.2411ZM1.49989 7.12489C1.49989 6.01237 1.82979 4.92483 2.44787 3.99981C3.06596 3.07478 3.94446 2.35381 4.97229 1.92807C6.00013 1.50232 7.13113 1.39093 8.22227 1.60797C9.31342 1.82501 10.3157 2.36074 11.1024 3.14741C11.889 3.93408 12.4248 4.93636 12.6418 6.02751C12.8588 7.11865 12.7475 8.24965 12.3217 9.27748C11.896 10.3053 11.175 11.1838 10.25 11.8019C9.32495 12.42 8.23741 12.7499 7.12489 12.7499C5.63355 12.7482 4.20377 12.1551 3.14924 11.1005C2.09471 10.046 1.50154 8.61622 1.49989 7.12489Z" fill="currentColor"></path></svg>
                    </button>
                </div>
            </div>
            <div id="rt-categories-3" class="widget rt-widget-category">
                <div class="rt-widget-title-holder">
                    <h3 class="widgettitle has-animation active-animation">Categories</h3>
                </div>					
                <div class="rt-widget-category-style2">
                    <ul>
                        <li class="rt-item" v-for=" item in categoryList">
                            <router-link :to="`/category/${item.name}`">
                                <div class="rt-content">
                                    <span class="rt-cat-name">
                                        {{ item.name }}					            
                                    </span>
                                    <span class="rt-cat-count">({{ item.blogCount }})</span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>		
            <div id="rt-post-box-2" class="widget rt-post-box">		
                <div class="rt-widget-title-holder">
                    <h3 class="widgettitle has-animation active-animation">Top Reviews</h3>
                </div>		
                <div class="post-box-style number-counter g-3 " v-for="item in topBlogs.slice(0,4)">
                    <div class="rt-news-box-widget box-style-1" @click="goBlog(item)">
                        <div class="item-list">
                            <div class="post-box-img">
                                <a class="post-img" >
                                    <img class="media-object wp-post-image wp-post-image" :src="item.firstPicture" alt="" decoding="async" style="max-width: 100%;height: auto;" title="">
                                </a>
                            </div>
                            <div class="post-content">
                                <h4 class="entry-title title-animation-black-normal">
                                    <a>{{ item.title }}</a>
                                </h4>
                                <div class="cat-ratint-wrap">							
                                    <div class="rtrs-rating-item">
                                        <div class="rating-icon">
                                            <el-rate
                                                v-model="item.rate"
                                                disabled
                                                show-score
                                                text-color="#000"
                                                score-template="">
                                            </el-rate>
                                            <span>({{ item.views }})</span>
                                        </div>	
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>	
        </aside>
    </div>
</template>

<script>
	import {getBlogsCategory} from "@/api/category";
    import {getSearchBlogList,getReviewsBlog} from "@/api/blog";
	export default {
		name: "MainSidebar",
		props: {

		},
        created(){
            this.getBlogsCategories()
            this.getReviewsBlogs()
        },
        data(){
            return{
                categoryList:[],
                topBlogs: [],
                service: 1.3,
                queryString: '',
				queryResult: [],
				mobileHide: true,
				timer: null,
            }
        },
        methods:{
			goBlog(item) {
				this.$router.push({
					path: `/${item.title}`
				});
			},
            handleSelect(item) {
				if (item.id) {
					this.$router.push(`/${item.title}`);
				}
			},
			debounceQuery(queryString, callback) {
				this.timer && clearTimeout(this.timer)
				this.timer = setTimeout(() => this.querySearchAsync(queryString, callback), 1000)
			},
			querySearchAsync(queryString, callback) {
				if (queryString == null
						|| queryString.trim() === ''
						|| queryString.indexOf('%') !== -1
						|| queryString.indexOf('_') !== -1
						|| queryString.indexOf('[') !== -1
						|| queryString.indexOf('#') !== -1
						|| queryString.indexOf('*') !== -1
						|| queryString.trim().length > 20) {
					return
				}
				getSearchBlogList(queryString).then(res => {
					if (res.code === 200) {
						this.queryResult = res.data
						if (this.queryResult.length === 0) {
							this.queryResult.push({title: '无相关搜索结果'})
						}
						callback(this.queryResult)
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
            getReviewsBlogs() {
				getReviewsBlog().then(res => {
					if(res.code == 200){
						this.topBlogs = res.data
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
            getBlogsCategories() {
				getBlogsCategory().then(res => {
					if(res.code == 200){
						this.categoryList = res.data
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
        }
	}
</script>

<style scoped>
	aside{
		display: block;
	}
	.sidebar-widget-area .widget {
		overflow: hidden;
		position: relative;
		box-shadow: 0px 0px 35px rgb(0 0 0 / 5%);
		background-color: #ffffff;
		border-radius: 10px;
		margin-bottom: 30px;
		padding: 40px 30px;
		transition: allease 0.31s;
	}
	.widget {
		margin: 0 0 1.5em;
	}
	.sidebar-widget-area .widget .widgettitle {
		display: flex;
		align-items: center;
		position: relative;
		color: #161f38;
		font-size: 20px;
		margin-bottom: 20px;
		padding-left: 15px;
		line-height: 1.4;
		z-index: 2;
		transition: all ease 0.31s;
	}
	.m-search {
		width: 260px;	
		border: 1px solid #eaeaea !important;
		padding: 0 !important;
		margin-right: 7px;
		border-radius: 6px !important;
	}

	.m-search input{
		color: #6c6f72 !important;
		/* border: 1px solid #000 !important; */
		background-color: inherit;
		padding: .67857143em 2.1em .67857143em 1em;
		font-size: 16px;
	}

	::v-deep .el-input__inner {
        /* background-color: #e8e8e8; */
        /* text-align: center; */
		height: 50px !important;
        border-color: #c0c4cc;
        color:#000 !important;
		font-size: 16px;
	}
	::v-deep .el-input__inner:focus {
		border-color: #000 !important;
		outline: 0;
	}

	::v-deep .el-input__inner::placeholder {
		color: #6c6f72;
		font-weight: 400;
		font-size: 16px;
	}
	.m-search-item {
		min-width: 350px !important;
	}

	.m-search-item li {
		line-height: normal !important;
		padding: 8px 10px !important;
	}

	.m-search-item li .title {
		text-overflow: ellipsis;
		overflow: hidden;
		color: rgba(0, 0, 0, 0.87);
	}

	.m-search-item li .text-content {
		text-overflow: ellipsis;
		font-size: 12px;
		color: rgba(0, 0, 0, .70);
	}
	.sidebar-widget-area .widget .widgettitle:before {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 4px;
		border-radius: 4px;
	}
	.sidebar-widget-area .widget .widgettitle:before, .sidebar-widget-area .widget ul li a:hover:before, .rtcl-widget-filter-class .panel-block .rtcl-filter-form .ui-accordion-item .ui-accordion-title:before {
		background-color: #2c3e50;
	}
	.sidebar-widget-area .widget .widgettitle.active-animation:before {
		height: 15px;
	}

	.sidebar-widget-area .widget .widgettitle.has-animation:before {
		/* height: 0; */
		transition: all ease 1s;
	}
	.sidebar-widget-area .widget .widgettitle {
		display: flex;
		align-items: center;
		position: relative;
		color: #161f38;
		font-size: 20px;
		margin-bottom: 20px;
		padding-left: 15px;
		line-height: 1.4;
		z-index: 2;
		transition: allease 0.31s;
	}
	.widget ul {
		margin: 0;
		padding: 0;
		list-style-type: none;
		/* list-style: disc inside none; */
	}
	.sidebar-widget-area .widget ul li:last-child {
		border-bottom: none;
		margin-bottom: 0;
		padding-bottom: 0;
	}
	.sidebar-widget-area .widget ul li {
		margin: 0 0 5px;
		padding: 0 0 5px;
		position: relative;
		transition: all ease 0.31s;
	}
	.sidebar-widget-area .rt-widget-category ul li a {
		display: block;
	}
	.sidebar-widget-area .widget ul li a {
		font-size: 16px;
		font-weight: 400;
		padding-left: 15px;
		position: relative;
		transition: all ease 0.31s;
	}
	.widget ul li a {
		color: #777777;
		display: inline;
		transition: all ease 0.31s;
	}
	.rt-widget-category-style2 .rt-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		column-gap: 15px;
	}
	.sidebar-widget-area .widget ul li a:before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		top: 50%;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		width: 2px;
		height: 10px;
		border-radius: 0;
		background-color: #ddd;
		transition: all 0.3s ease;
	}
	.post-box-style .rt-news-box-widget {
		position: relative;
		padding-bottom: 25px;
		display: inline-block;
		transition: all 140ms ease-in-out;
	}
	.post-box-style .item-list {
		display: flex;
		align-items: center;
	}
	.item-list:hover .wp-post-image{
		transform: scale(1.1);
	}
	.post-box-style .post-box-img {
		position: relative;
		margin-right: 15px;
		overflow: hidden;
		border-radius: 10px;
		max-width: 100px;
	}
	.post-box-style .item-list .post-box-img img {
		transition: all 1s cubic-bezier(0.25, 0.8, 0.25, 1);
	}
	.post-box-style .post-content .entry-title {
		font-size: 16px;
		margin-bottom: 0px;
		line-height: 1.5;
		overflow: hidden;
		-o-text-overflow: ellipsis;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.post-box-style .post-content .entry-title a {
		color: #161f38;
	}
	.title-animation-black-normal a {
		background-image: linear-gradient(to right, #161f38 0%, #161f38 98%);
		background-repeat: no-repeat;
		background-position: left 90%;
		background-size: 0 2px;
		transition: all 0.7s;
	}
	.post-box-style .cat-ratint-wrap {
		margin-top: 5px;
		margin-bottom: 0;
		line-height: 1.4;
	}
	.cat-ratint-wrap {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 13px;
	}
    .rtrs-rating-item .rating-icon {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
		line-height: 1;
	}
</style>